<div class="sheet" role="dialog" aria-modal="true" aria-labelledby="sheetTitle">

  <div class="sheet-grabber" aria-hidden="true"></div>

  <div class="sheet-head">
    <div class="sheet-heading" *ngIf="!isPostCreate">
      <h2 class="sheet-title" id="sheetTitle">Tell us about your event</h2>
    </div>

    <!-- Legacy share step only (newInviteDesign off). -->
    <div class="sheet-heading" *ngIf="isPostCreate">
      <div class="sheet-created">
        <svg class="created-tick" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.6" aria-hidden="true">
          <path d="M5 12.5l4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Event created
      </div>
      <h2 class="sheet-title" id="sheetTitle">Send the invite to start collecting photos</h2>
      <p class="sheet-sub">This card is what guests see when you share the link.</p>
    </div>

    <button type="button" class="sheet-close" (click)="close()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
        <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div class="sheet-body" [class.sheet-body--invite]="isPostCreate">
    <!-- The shared create form — the same component as the new-user page. -->
    <app-create-event-form
      *ngIf="step === 'form'"
      surface="sheet"
      [initialHostedBy]="accountName"
      footnote="Date, cover and privacy are all editable later"
      (workingChange)="isCreating = $event"
      (created)="onCreated($event)"
      (editExisting)="editExisting($event)">
    </app-create-event-form>

    <!-- Legacy share step (newInviteDesign off). With it on, the invite opens
         as its own dialog instead — see handOffToInviteDialog(). -->
    <app-invite-share
      *ngIf="step === 'invite' && created"
      [eventId]="created.eventId"
      [eventName]="created.eventName"
      [eventStartTime]="created.start"
      [coverImageUrl]="created.coverImage || ''"
      [hostName]="created.hostedBy"
      [compact]="true"
      surface="sheet"
      (browseTemplates)="browseInviteTemplates()">
    </app-invite-share>
  </div>

</div>
